import React from 'react';

const SizeClothes = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_4217_136)">
            <g clipPath="url(#clip1_4217_136)">
                <path
                    d="M15.5 3.0199C15.5 3.41125 15.4229 3.79878 15.2732 4.16034C15.1234 4.52191 14.9039 4.85044 14.6271 5.12717C14.3504 5.4039 14.0219 5.62341 13.6603 5.77318C13.2988 5.92294 12.9112 6.00003 12.5199 6.00003H11.4801C11.0888 6.00003 10.7012 5.92294 10.3397 5.77318C9.97812 5.62341 9.64959 5.4039 9.37286 5.12717C8.81398 4.56828 8.5 3.81028 8.5 3.0199"
                    stroke="#323232"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.9878 13.996L21.2293 13.2324C21.3582 13.2021 21.4798 13.1464 21.5871 13.0686C21.6943 12.9909 21.785 12.8925 21.854 12.7794C21.9229 12.6663 21.9687 12.5406 21.9886 12.4097C22.0085 12.2787 22.0023 12.1451 21.9701 12.0166L20.6744 6.83366C20.5311 6.26034 20.2625 5.7259 19.888 5.26876C19.5134 4.81163 19.0423 4.44317 18.5083 4.18987L16.814 3.38607C16.2782 3.13187 15.6926 3 15.0995 3H8.90095C8.3079 3 7.72227 3.13187 7.18646 3.38607L5.49215 4.18987C4.95822 4.44317 4.48705 4.81163 4.11252 5.26876C3.73798 5.7259 3.46939 6.26034 3.32606 6.83366L2.03034 12.0165C1.99822 12.1451 1.99194 12.2787 2.01189 12.4096C2.03184 12.5406 2.07761 12.6663 2.14654 12.7794C2.21547 12.8925 2.30619 12.9908 2.41343 13.0686C2.52067 13.1464 2.6423 13.2021 2.77124 13.2324L5.98774 13.9901"
                    stroke="#323232"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.00024 11L6.00012 19.5433C5.9953 19.98 6.13541 20.4059 6.3985 20.7545C6.6616 21.1031 7.03284 21.3546 7.45412 21.4697C10.4436 22.1768 13.5569 22.1768 16.5464 21.4695C16.9676 21.3544 17.3388 21.1028 17.6018 20.7543C17.8649 20.4057 18.0049 19.9797 18.0001 19.5431L18 11"
                    stroke="#323232"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_4217_136">
                <rect width="24" height="24" fill="white" />
            </clipPath>
            <clipPath id="clip1_4217_136">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default SizeClothes;
